<template>
  <div>
    <!-- Header -->
    <Header />
    <div class="container">
      <transition name="fade" mode="out-in">
        <!-- route viewer -->
        <router-view />
      </transition>
    </div>
  </div>
</template>


<script>
import Header from "./components/Header";

export default {
  components: { Header },
  mounted() {
    this.$store.dispatch("isAuth").then(response => {
      // if auth get user and info
      if (response) {
        this.$store
          .dispatch("getUser", this.$store.getters.getToken)
          .then(response => {
            this.$store.commit("setUser", response.data);
          });

        this.$store
          .dispatch("info")
          .then(response => this.$store.commit("setInfo", response.data));
      }
    });
  }
};
</script>


<style>
i {
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transition: opacity .5s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue